import type { Product } from "../types";

export const MOCK_PRODUCTS: Product[] = [
  {
    id: 1,
    name: "Wireless Bluetooth Headphones",
    price: 79.99,
    description:
      "High-quality wireless headphones with noise cancellation and 30-hour battery life.",
    image:
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop",
    category: "Electronics",
  },
  {
    id: 2,
    name: "Organic Cotton T-Shirt",
    price: 24.99,
    description:
      "Soft, comfortable organic cotton t-shirt available in multiple colors.",
    image:
      "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop",
    category: "Clothing",
  },
  {
    id: 3,
    name: "Stainless Steel Water Bottle",
    price: 19.99,
    description:
      "Insulated stainless steel water bottle that keeps drinks cold for 24 hours.",
    image:
      "https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=400&h=400&fit=crop",
    category: "Lifestyle",
  },
  {
    id: 4,
    name: "Leather Crossbody Bag",
    price: 89.99,
    description:
      "Genuine leather crossbody bag with adjustable strap and multiple compartments.",
    image:
      "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
    category: "Accessories",
  },
  {
    id: 5,
    name: "Smart Fitness Watch",
    price: 199.99,
    description:
      "Advanced fitness tracking watch with heart rate monitor and GPS.",
    image:
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=400&fit=crop",
    category: "Electronics",
  },
  {
    id: 6,
    name: "Ceramic Coffee Mug Set",
    price: 34.99,
    description:
      "Set of 4 handcrafted ceramic coffee mugs with unique glazed finish.",
    image:
      "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=400&h=400&fit=crop",
    category: "Home",
  },
  {
    id: 7,
    name: "Yoga Mat Pro",
    price: 45.99,
    description:
      "Premium non-slip yoga mat with alignment guides and carrying strap.",
    image:
      "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=400&fit=crop",
    category: "Sports",
  },
  {
    id: 8,
    name: "Wireless Phone Charger",
    price: 29.99,
    description:
      "Fast wireless charging pad compatible with all Qi-enabled devices.",
    image:
      "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=400&fit=crop",
    category: "Electronics",
  },
];
